import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto">
      <div className="container mx-auto text-center">
        <p>&copy; 2024 My Blog. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
